import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileTextOutlined, KeyOutlined, RiseOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { __ } from "../../../../utils/i18n.js";
import { KeyBenefit } from "../keyBenefit.js";
/**
 * Right-column companion for the unauthenticated sign-in surface. Mirrors the
 * three customer-center tabs (subscriptions/licenses, invoices, affiliate) so
 * anonymous visitors see what's behind the magic-link sign-in instead of
 * staring at an empty page. The card stretches to match the form-card's
 * height through CSS Grid; content is vertically distributed via
 * `justify-content: space-between` to absorb the extra space gracefully.
 */ const UnauthFeatures = ()=>{
    const { token } = theme.useToken();
    const iconStyle = {
        color: token.colorPrimary
    };
    return /*#__PURE__*/ _jsxs("aside", {
        className: "rc-account-v2-unauth-features",
        style: {
            background: token.colorBgLayout,
            borderColor: token.colorBorder
        },
        "aria-labelledby": "rc-account-v2-unauth-features-heading",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                id: "rc-account-v2-unauth-features-heading",
                className: "rc-account-v2-unauth-features__heading",
                style: {
                    color: token.colorTextSecondary
                },
                children: __("What you'll find inside")
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-unauth-features__list",
                children: [
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        icon: /*#__PURE__*/ _jsx(KeyOutlined, {
                            style: iconStyle
                        }),
                        heading: __("Subscriptions and licenses"),
                        body: __("Download your WordPress plugins and manage everything you have activated.")
                    }),
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        icon: /*#__PURE__*/ _jsx(FileTextOutlined, {
                            style: iconStyle
                        }),
                        heading: __("Invoices"),
                        body: __("Download tax-compliant PDF invoices for every purchase.")
                    }),
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        icon: /*#__PURE__*/ _jsx(RiseOutlined, {
                            style: iconStyle
                        }),
                        heading: __("Affiliate center"),
                        body: __("Generate links, run promotions, and track your commissions and payouts.")
                    })
                ]
            })
        ]
    });
};
export { UnauthFeatures };
